import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import BuyButton from './BuyButton';

const sameCategory = (item, index, array) =>
  (index > 0 && array[index - 1].category === array[index].category) ||
  item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  const showBuyButtons = window.__litium.constants.showBuyButtons;
  return (
    <ul className="quick-search-result">
      {result &&
        result.map((item, index, array) => (
          <Fragment key={`${item.name}-${index}`}>
            {item.category === 'NoHit' ||
              sameCategory(item, index, array) ? null : (
              <li className="quick-search-result__item quick-search-result__group-header">
                {item.category}
              </li>
            )}
            <li
              className={`quick-search-result__item ${selectedItem === index
                ? 'quick-search-result__item--selected'
                : ''
                }`}
            >
              <a
                className={
                  item.showAll
                    ? 'quick-search-result__show-all'
                    : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'
                    }`
                }
                href={item.showAll ? searchUrl : item.url}
              >
                {item.hasImage && item.imageSource && (
                  <div className="quick-search-result__link--image">
                    <img
                      className="quick-search-result__image"
                      src={item.imageSource}
                    />
                  </div>
                )}
                {item.hasImage == false &&
                  item.categoryWithoutTransilation == 'Categories' && (
                    <div className="quick-search-result__link--image"></div>
                  )}
                <div className="quick-search-result__item--product">
                  <div className="quick-search-result__name-button">
                    {item.name && (
                      <h3 className="quick-search-result__item--product--header">
                        {item.name}
                      </h3>
                    )}
                    {showBuyButtons && item.enableBuyButton && (
                      <span className='quick-search-result__button'>
                        <BuyButton
                          articleNumber={item.articleNumber}
                          minValue={1}
                          cssClass="button buy-button product__buy-button"
                          label={translate('button.addtocart')}
                        ></BuyButton>
                      </span>
                    )}
                  </div>
                  {item.breadcrumb && (
                    <div className="item-breadcrumbs">{item.breadcrumb}</div>
                  )}
                  {item.articleNumber && (
                    <div className="article-number">
                      {translate(`quicksearch.articlenumber`)}:{' '}
                      {item.articleNumber}
                    </div>
                  )}
                  {item.description && (
                    <div className="description">{item.description}</div>
                  )}
                </div>
              </a>
            </li>
          </Fragment>
        ))}
    </ul>
  )
};

export default QuickSearchResult;
